export const sleep = (seconds: number) => new Promise<void>(res => setTimeout(res, seconds * 1e3));
